var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonsGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.198,
    height: 17.677,
    viewBox: "0 0 23.198 17.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.245 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.609 1.71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.257,469.734h4.365V465c0-1.689-1.084-3.058-2.422-3.058h-.577a3.047,3.047,0,0,0,1.242-2.57,2.351,2.351,0,1,0-4.578,0,3.047,3.047,0,0,0,1.242,2.57",
    transform: "translate(-324.288 -456.478)",
    fill: "rgba(253,153,38,0.1)",
    stroke: "#0c4767",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.745 1.71)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.162,469.734H213.8V465c0-1.689,1.084-3.058,2.422-3.058h.577a3.048,3.048,0,0,1-1.242-2.57,2.351,2.351,0,1,1,4.578,0,3.047,3.047,0,0,1-1.242,2.57",
    transform: "translate(-213.797 -456.478)",
    fill: "rgba(253,153,38,0.1)",
    stroke: "#0c4767",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.3,450.684h-.765a3.771,3.771,0,0,0,1.647-3.234c0-2.008-1.359-3.636-3.034-3.636s-3.035,1.628-3.035,3.636a3.771,3.771,0,0,0,1.647,3.234h-.765c-1.773,0-3.211,1.722-3.211,3.847v5.96h10.727v-5.96C263.509,452.407,262.071,450.684,260.3,450.684Z",
    transform: "translate(-252.782 -443.815)",
    fill: "rgba(253,153,38,0.1)",
    stroke: "#fd9926",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonsGroup);
export default __webpack_public_path__ + "static/media/persons_group.ff02d8cd6e422392885c0bcbb0f6c0f1.svg";
export { ForwardRef as ReactComponent };